import {EditableFieldModel} from "@white-label/components/page-builder/models/edit-component.model";
import {FieldType} from "@white-label/components/page-builder/models/model.map";

export enum CardTypes  {
    default = 'default',
    feature = 'feature',
    media = 'media',
    blog = 'blog',
    member = 'member',
    event = 'event',
}

export class CardModel {
    video = new EditableFieldModel('video', FieldType.video, '/assets/image/default-image.png');
    image = new EditableFieldModel('image', FieldType.image, '/assets/image/default-image.png');

    title = new EditableFieldModel('Card title', FieldType.text, 'Card title');
    description = new EditableFieldModel('Card description', FieldType.embed, 'A little more about card');
    metaData = new EditableFieldModel('Add anything else you want to show without highlight', FieldType.embed, '');
    link = new EditableFieldModel('Card navigation link (Optional)', FieldType.link, '');
    spacing = new EditableFieldModel('Spacing', FieldType.size, 'xs');

    fieldsMap = [this.video,this.image,this.spacing, this.title, this.description, this.link];

    constructor(data?: { video?: any, image?: any, title?: any, description?: any, link?: any, spacing?: any }) {
        if(data?.video?.value){
            this.video.value = data.video.value;
        }
        if(data?.image?.value){
            this.image.value = data.image.value;
        }
        if(data?.title?.value){
            this.title.value = data.title.value;
        }
        if(data?.description?.value){
            this.description.value = data.description.value;
        }
        if(data?.link?.value){
            this.link.value = data.link.value;
        }
        if(data?.spacing?.value){
            this.spacing.value = data.spacing.value;
        }
    }
}